$.widget 'zebra.appendArbitraryProduct', {
    options: {
        append: null
        create: true
        label: 'В операцию'
        placeholder: 'Найти товар...'
        classes: [
            'TblTovarPrice',
            'TblTovar',
            'TblNlTovar',
            'TblTechnopointPrice'
        ]
    }

    _create: ->
        @element.attr( 'pluginname', 'appendArbitraryProduct' )

        @formId = @element.attr( 'data-form-id' )
        @operId = @element.attr( 'data-oper-id' )
        @winId = @element.attr( 'data-win-id' )

        label = @element.attr( 'data-label' )
        if label?
            @options.label = label

        placeholder = @element.attr( 'data-placeholder' )
        if placeholder?
            @options.placeholder = placeholder

        @_with_accountant_remainder = @element.attr( 'data-with-accountant-remainder' )?

        @location = "/index.php?id=#{@formId}&idform=#{@operId}&op=restore"
        @appendUrl = "/static2/append_arbitrary_product.php"
        @product = null

        check = $( '<input type="checkbox">' )
        @remainder_check = check
        if @_with_accountant_remainder
            @element.append( check )
            check.on( 'change', ( ) =>
                if check.prop( 'checked' )
                    @_add_accountant_remainder_class( )
                else
                    @_remove_accountant_remainder_class( )
            )

        search = $( "<input placeholder='#{@options.placeholder}' type='search'>" );
        @element.append( search );

        @search = search.search( {
            showCategory: true
            showFilter: true
            delay: 100000
            appClasses: @options.classes } );


        @search.on( 'searchselect', ( event, ui ) =>
            @onSelect ui.item.item
        )

        createNew = $( '<button></button>' ).appendTo( @element );
        @createNew = createNew.button( {
            label: '+'
        } ).click( ( ev )=>
            ev.preventDefault( )
            @createNewProduct( )
        )
        if not @options.create
            createNew.hide( )

        append = $( "<button>#{@options.label}</button>" )
        @element.append( append )
        @append = append.button( ).click( ( e ) =>
            e.preventDefault( );
            @onAppendClick( )
        )

        @oldAddButton = $( '<button>Произв. товар</button>' ).appendTo( @element ).button( ).click( ( e )=>
            e.preventDefault( )
            data = {
                art: 2219
                class: 'TblTovar'
                operation: @operId
            }
            $.post( @appendUrl, data ).then( ( ) =>
                window.location = @location
            )
        )

    _add_accountant_remainder_class: ( ) ->
        classes = @options.classes
        if classes.indexOf( 'AccountantRemainder' ) == -1
            classes.push( 'AccountantRemainder' )

    _remove_accountant_remainder_class: ( ) ->
        classes = @options.classes
        i = classes.indexOf( 'AccountantRemainder' )
        if i != -1
            classes.splice( i, 1 )

    onAppendClick: ( ) ->
        fn = @options.append
        if fn? and typeof fn == 'function'
            fn( @product )
        else
            @_append_item_to_operation( )

    _append_item_to_operation: ( ) ->
        if @product
            @search.addClass( 'in-progress' )
            new Promise( ( resolve, reject ) =>
                $.post( @appendUrl, @product ).done( ( response, status, xhr ) =>
                    ZW.PHPErrorCheck( response, reject )
                    window.location = @location
                    resolve response
                ).fail( ( xhr, status, error ) =>
                    ZW.HandleError( error )
                    reject( error )
                )
            )

    onSelect: ( item ) ->
        @product = {
            id: item.id
            art: @_getArt( item )
            class: item.appClass
            operation: @operId
        }

    _getArt: ( item ) ->
        if 'art' of item
            return "#{item.art}"
        if 'code' of item
            return "#{item.code}"
        if 'nlId' of item
            return "#{item.nlId}"
        return item.id

    createNewProduct: ->
        ZW.ItemFormFactory( 'TblTovar' ).then( ( form )=>
            form.data( {
                    model: @search.val( )
                    idEd: 1
                    idGarantProizv: 1
                    idGarantZebra: 1
                }
            )

            form.show( )
            form.subscribe( 'onSave', ( data )=>
                @search.val( data.label )
                data.appClass = 'TblTovar'
                @onSelect data
            )
        )
}
